import * as _2021 from './2021/autosivu-2021';
import * as _2026 from './2026/autosivu-2026';

function init() {
  _2021.init();
  _2026.init();
}

export default { init };
